import { useState, useEffect } from 'react'
export const useDevice = () => {
  const [isMobile, setIsMobile] = useState(false)
  const [isTablet, setIsTablet] = useState(false)
  const [isDesktop, setIsDesktop] = useState(false)
  const screenWidth = window.screen.width

  useEffect(() => {
    if (screenWidth > 960) setIsDesktop(true)
    if (screenWidth < 850 && screenWidth > 600) setIsTablet(true)
    if (screenWidth < 600) setIsMobile(true)
  }, [])

  return { isMobile, isDesktop, isTablet }
}
